import { RESET_ALL_CURRENCIES } from '../mutation-types';

// state
const localState = () => ({
  coins: [],
  cashes: [],
});

// getters
const localGetters = {
  totalType: () => (moneyTypes) => {
    let total = 0;
    moneyTypes.forEach((type) => {
      total += type.value * type.qty;
    });

    return total;
  },

  total: ({ coins, cashes }, getters) => {
    const { totalType } = getters;
    return totalType(coins) + totalType(cashes);
  },
};

// mutations
const mutations = {
};

// actions
const actions = {
  resetCashCalc({ state, rootState }) {
    const coins = [];
    rootState.auth.currency.coin.forEach(coin => {
      coins.push({
        id: parseFloat(coin),
        value: parseFloat(coin),
        qty: ''
      });
    });
    coins.sort((a, b) => a.id - b.id);
    let cashes = [];
    rootState.auth.currency.bill.forEach(bill => {
      cashes.push({
        id: parseFloat(bill),
        value: parseFloat(bill),
        qty: ''
      });
    });
    cashes.sort((a, b) => a.id - b.id);
    Object.assign(state, {coins, cashes});
  },
};

export default {
  state: localState(),
  getters: localGetters,
  mutations,
  actions
};
